module.exports = __webpack_public_path__ + "static/media/msme.82f311ba.png";